import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { CompanyDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, { id: string; payload: Partial<CompanyDto> }>({
        query: ({ id, payload }) => ({
            url: `${APP_ENDPOINTS.COMPANY}/${id}`,
            method: 'PATCH',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'companies-with-join', id: 'GET-JOIN' },
            { type: 'companies', id: 'GET' },
            { type: 'company', id: 'GET-ID' },
            { type: 'company-owners', id: 'GET' },
            { type: 'company-owners-with-join', id: 'GET-JOIN' },
        ],
    });
